<template>
  <div class="flex-column">
    <!--    粘性布局-->
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <!--        自定义按钮-->
        <permission-btn moduleName='inventorys' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <!--      栅格布局-->
      <el-row class="fh">
        <el-col :span="8" class="fh ls-border">
          <el-card shadow="never" class="card-body-none fh" style="overflow-y: auto">
            <div slot="header" class="clearfix">
              <!--              点击所有存货，展示所有数据-->
              <el-button type="text" style="padding: 0 11px" @click="getAllMenus">所有存货>></el-button>
            </div>
            <!--            树形结构的表格   columns：查看所选择的某一个连续范围内的一系列单元格的总列数-->
            <tree-table highlight-current-row :data="modulesTree" :columns="columns" @row-click="treeClick"
                        border></tree-table>
          </el-card>
        </el-col>
        <el-col :span="16" class="fh ls-border">
          <div class="bg-white fh" id='inventorys-table'>
            <!--            表格-->
            <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit
                      highlight-current-row
                      style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                      @selection-change="handleSelectionChange" @sort-change="handleSortChange">
              <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
              <el-table-column type="selection" align="center" width="55"></el-table-column>
              <!--              v-for="(item, index) in headerList":表头。prop：父组件用来传递数据的一个自定义属性。-->
              <!--              show-overflow-tooltip：可以让内容在一行显示，如果显示不下时，显示...,并且鼠标划过时显示全部文字。-->
              <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                               :label="item.description"
                               :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                               :show-overflow-tooltip="item.tooltip">
                <template slot-scope="scope">
                  <!--                  isEdit：是否可编辑   ref：被用来给元素或组件注册引用信息（id的替代者）-->
                  <select-type ref="selectType" :isEdit="false" :typeId="item.isSel"
                               :value="scope.row[item.key].toString()"
                               v-if="item.isSel">
                  </select-type>
                  <span v-else>
<!--                    v-if：是否显示时间-->
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{
                    scope.row[item.key] | dateFormat
                  }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
                </template>
              </el-table-column>
            </el-table>
            <!--            分页功能-->
            <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                        :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
          </div>
        </el-col>
      </el-row>

      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <!--      添加功能   sync：同步-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="inventorys-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData" :soltNameArray="soltNameArray">
        <!--        添加页面的自定义组件，树形结构   ormalizer：treeselect定义字段  options：存放子组件的数据
        multiple：是否多选   open-on-click：获取点击    open-on-focus：获取焦点    clear-on-select：清除选择-->
        <treeselect slot="cInvCCode" :normalizer="normalizer" :options="modulesTreeRoots"
                    :multiple="false" :open-on-click="true" :open-on-focus="true"
                    :clear-on-select="true"
                    v-model="dpSelectModules"></treeselect>
        <!--        表格-->
        <el-table
          slot="lkList"
          :data="initData.lkList"
          border
        >
          <el-table-column type="index" fixed="left" width="50" label="序号"></el-table-column>
          <!--          表格里嵌套input，readonly是设置只读-->
          <el-table-column label="账套名称" prop="accName" align="center" min-width="150">
            <template slot-scope="scope">
              <el-input readonly :value="scope.row.accName"/>
            </template>
          </el-table-column>
          <el-table-column label="Erp存货编码" prop="LinkcInvCode" align="center" min-width="300">
            <template slot-scope="scope">
              <!--              显示切换按钮，绑定linkcInvNam和linkcInvCode-->
              <el-input v-if="!scope.row.edit" readonly
                        :value="scope.row.linkcInvName?scope.row.linkcInvName+'('+scope.row.linkcInvCode+')':''">
                <!--                切换的那个按钮-->
                <el-button slot="append" icon="el-icon-search" @click="()=>{rowdearchbtn(scope)}"></el-button>
              </el-input>
              <!--              下拉列表 绑定v-model，filterable是可输入文字进行筛选，remote远程搜素，reserve-keyword：多选且可搜索时，是否在选中一个选项后保留当前的搜索关键词
              remote-method启用远程搜素，自定义方法，@change：里面写的选择下拉列表的某一行
              @ visible-change 函数里面传递两个参数（第一个为回调参数，第二个为自己定义的参数） 下拉框出现/隐藏时触发-->
              <el-select
                v-else
                v-model="scope.row.linkcInvCode"
                filterable
                remote
                reserve-keyword
                placeholder="请输入存货编号或者名称"
                :remote-method="(query)=>{remoteMethod(query,scope.row.accountId)}"
                @change="(val)=>{selectChange(val,scope.row)}"
                @visible-change="(val)=>{if(!val){scope.row.edit=false}}"
                :loading="selloading">
                <!--                el-option：下拉绑定   option：树形结构的数据-->
                <el-option
                  v-for="item in options"
                  :key="item.linkcInvCode"
                  :label="item.linkcInvName+'('+item.linkcInvCode+')'"
                  :value="item.linkcInvCode">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <!--          prop：父组件用来传递数据的一个自定义属性-->
          <el-table-column label="安全库存" prop="safetyStock" align="center" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.safetyStock" type="number"/>
            </template>
          </el-table-column>
        </el-table>
      </add-instance>

      <!--      编辑功能   sync：同步-->
      <edit-instance ref="editForm" :sourceCode="crmType"
                     createdFormId="inventorys-dialog"
                     :visible.sync="dialogEditVisible"
                     :initData="temp" :soltNameArray="soltNameArray">
        <!--        编辑页面的自定义组件，树形结构   ormalizer：treeselect定义字段  options：存放子组件的数据
     multiple：是否多选   open-on-click：获取点击    open-on-focus：获取焦点    clear-on-select：清除选择-->

        <treeselect slot="cInvCCode" :normalizer="normalizer" :options="modulesTreeRoots"
                    :multiple="false" :open-on-click="true" :open-on-focus="true"
                    :clear-on-select="true"
                    v-model="dpSelectModules"></treeselect>
        <el-table
          slot="lkList"
          :data="temp.lkList"
          border
        >
          <!--          表格里嵌套input，readonly是设置只读-->
          <el-table-column type="index" fixed="left" width="50" label="序号"></el-table-column>
          <el-table-column label="账套名称" prop="accName" align="center" min-width="150">
            <template slot-scope="scope">
              <el-input readonly :value="scope.row.accName"/>
            </template>
          </el-table-column>
          <!--   显示切换按钮，绑定linkcInvNam和linkcInvCode-->
          <el-table-column label="Erp存货编码" prop="LinkcInvCode" align="center" min-width="300">
            <template slot-scope="scope">
              <el-input v-if="!scope.row.edit" readonly
                        :value="scope.row.linkcInvName?scope.row.linkcInvName+'('+scope.row.linkcInvCode+')':''">
                <!--                切换的那个按钮-->
                <el-button slot="append" icon="el-icon-search" @click="()=>{rowdearchbtn(scope)}"></el-button>
              </el-input>
              <!--    下拉列表 绑定v-model，filterable是可输入文字进行筛选，remote远程搜素，reserve-keyword：多选且可搜索时，是否在选中一个选项后保留当前的搜索关键词
remote-method启用远程搜素，自定义方法，@change：里面写的选择下拉列表的某一行
@ visible-change 函数里面传递两个参数（第一个为回调参数，第二个为自己定义的参数） 下拉框出现/隐藏时触发-->
              <el-select
                v-else
                v-model="scope.row.linkcInvCode"
                filterable
                remote
                reserve-keyword
                placeholder="请输入存货编号或者名称"
                :remote-method="(query)=>{remoteMethod(query,scope.row.accountId)}"
                @change="(val)=>{selectChange(val,scope.row)}"
                @visible-change="(val)=>{if(!val){scope.row.edit=false}}"
                :loading="selloading">
                <!--    el-option：下拉绑定   option：树形结构的数据-->
                <el-option
                  v-for="item in options"
                  :key="item.linkcInvCode"
                  :label="item.linkcInvName+'('+item.linkcInvCode+')'"
                  :value="item.linkcInvCode">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <!--          prop：父组件用来传递数据的一个自定义属性-->
          <el-table-column label="安全库存" prop="safetyStock" align="center" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.safetyStock" type="number"/>
            </template>
          </el-table-column>
        </el-table>
      </edit-instance>
      <!--sync:同步 -->
      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>
      <!--用户需求不同，展示的列不同-->
      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>
      <!--抽屉-->
      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>
      <input ref="uploadInput" @change="handleChange" type="file" :style="{width:0, height: 0}" name="files"/>
    </div>
  </div>
</template>

<script>
// 导入该模块的api
import * as inventorys from '@/api/inventorys';
// 导入accinfos的api
import * as accinfos from '@/api/accinfos';
// mutable修饰的变量，将永远处于可变的状态，即使在一个const函数中
import mytable from '@/utils/crmtableFlowV2';
// 导入inventoryclasss模块的api
import * as inventoryclasss from '@/api/inventoryclasss';
// 导入树形表格
import treeTable from '@/components/TreeTable';
// 导入树形结构插件
import Treeselect from '@riophae/vue-treeselect';
// 导入样式
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
// 导入erpinventorys的api
import * as erpinventorys from '@/api/erpinventorys';
import * as txCompareForms from '@/api/tx_compareforms';
import { getToken } from '@/utils/auth';

export default {
  name: 'inventorys',
  // 引入组件
  components: { treeTable, Treeselect },
  // mixins：分发 Vue 组件中可复用功能的非常灵活的方式
  mixins: [mytable],
  data() {
    return {
      crmType: 'Inventory', // 自定义类型
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: { // 绑定数据
        cInvCCode: '',
        lkList: []
      },
      rules: {},
      selloading: false, // 关闭加载旋转
      normalizer(node) {
        // treeselect定义字段
        return {
          label: node.cInvCName,
          id: node.cInvCCode,
          children: node.children
        };
      },
      options: [], // 树形结构的数据
      selectMenus: [], // 菜单列表选中的值
      modules: [], // 模块
      modulesTree: [], // 树形模块
      soltNameArray: ['cInvCCode', 'lkList'], // 放solt插槽的名称
      columns: [
        // treetable的列名
        {
          text: '分类编号',
          value: 'cInvCCode'
        },
        {
          text: '分类名称',
          value: 'cInvCName'
        }
      ],
      modulesTrees: [],
      selectMenuss: [], // 菜单列表选中的值
      moduless: [],
      action: process.env.VUE_APP_BASE_API
    };
  },
  // 计算属性
  computed: {
    // 树形数据的属性
    modulesTreeRoots() {
      const root = [{
        cInvCName: '根节点',
        parentCode: '',
        id: '',
        cInvCCode: '',
        cInvName: ''
      }];
      // 把两个数组合并
      return root.concat(this.modulesTrees);
    },
    dpSelectModules: {
      // 模块编辑框下拉选中的模块
      get: function() {
        if (this.dialogFormVisible) {
          return this.initData.cInvCCode;
        } else {
          return this.temp.cInvCCode;
        }
      },
      set: function(v) {
        // 如果是根节点
        if (v === undefined || v === null || !v) {
          if (this.dialogFormVisible) {
            this.$refs['dataForm'].$refs['frmData'].AssignmentModel('cInvCCode', null);
          } else {
            this.$refs['editForm'].$refs['frmEditData'].AssignmentModel('cInvCCode', null);
          }
          return;
        }
        if (this.dialogFormVisible) {
          this.$refs['dataForm'].$refs['frmData'].AssignmentModel('cInvCCode', v);
        } else {
          this.$refs['editForm'].$refs['frmEditData'].AssignmentModel('cInvCCode', v);
        }
      }
    },
    isRoot: {
      get() {
        return this.chkRoot;
      },
      set(v) {
        this.chkRoot = v;
        if (v) {
          this.temp.parentName = '根节点';
          this.temp.parentId = null;
        }
        // this.treeDisabled = v
      }
    },
    // 树形数据的属性
    modulesTreeRoot() {
      const root = [{
        name: '根节点',
        parentId: '',
        id: '',
        cInvCCode: ''
      }];
      // 把两个数组合并
      return root.concat(this.modulesTree);
    },
    // 分页属性
    currentPageMenus: {
      get() {
        var start = (this.listQuery.page - 1) * this.listQuery.limit;
        var end = (this.listQuery.page * this.listQuery.limit);
        var result = this.list.slice(start, end);
        return result;
      }
    },
    dpSelectModule: {
      // 模块编辑框下拉选中的模块
      get: function() {
        if (this.dialogStatus === 'update') {
          return this.temp.parentId || '';
        } else {
          return '';
        }
      },
      set: function(v) {
        if (v === undefined || v === null || !v) {
          // 如果是根节点
          this.temp.parentName = '根节点';
          this.temp.parentId = null;
          // this.isRoot = true
          return;
        }
        // this.isRoot = false
        this.temp.parentId = v;
        var parentname = this.moduless.find(val => {
          return v === val.id;
        }).name;
        this.temp.parentName = parentname;
      }
    }
  },
  // 在created函数中调用ajax获取页面初始化所需的数据
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId(); // 查询条件
  },
  mounted() {
    // 初始化页面完成后，刷新树形结构
    this.getModulesTree();
  },
  methods: {
    // 调该页面api的方法
    getApi() {
      return inventorys;
    },
    btnClickOther(bomid) {
      switch (bomid) {
        case 'btnImportExcel':
          this.$refs.uploadInput.click();
          break;
      }
    },
    handleChange() {
      // 选择文件后触发
      const files = this.$refs.uploadInput.files;
      if (files.length > 1) {
        this.$notify({
          title: '警告',
          message: '只能选择一个文件，上传失败',
          type: 'warning',
          duration: 0
        });
      }
      const file = files[0];
      if (file.size > 5 * 1024 * 1024) {
        this.$notify({
          title: '警告',
          message: '文件:' + file.name + '过大，上传失败',
          type: 'warning',
          duration: 0
        });
        return;
      }
      const reader = new FileReader();// 文件类
      const loading = this.$loading({
        lock: true,
        text: '读取文件中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      reader.readAsDataURL(file); // 读取文件
      reader.onload = () => {
        this.$nextTick(() => {
          this.uplaodAction(reader.result, file, loading);// 文件上传
        });
      };
      this.$refs.uploadInput.value = '';
    },
    // 上传
    uplaodAction(res, file, loading) {
      const xhr = new XMLHttpRequest();
      const url = this.action + '/Inventorys/ImportInventory';
      xhr.open('POST', url, true);
      xhr.setRequestHeader('X-Token', getToken()); // 添加token
      const formData = new FormData();
      formData.append('files', file);
      xhr.send(formData);// 添加上传的文件
      xhr.onreadystatechange = () => {
        // 上传返回
        if (xhr.readyState === 4) {
          const resData = JSON.parse(xhr.response);
          console.log('resData', resData);
          if (resData.code !== 200) {
            this.$notify({
              title: '警告',
              message: '文件上传失败:' + resData.message,
              type: 'warning',
              duration: 0
            });
          } else {
            this.getList();
          }
        }
        loading.close();
      };
      xhr.onprogress = (res) => {
        if (res.currentTarget.status !== 200) {
          this.$message.error(res.currentTarget.responseText);
        }
      };
    },
    // 点击所有存货，展示所有数据的方法  listQuery查询
    getAllMenus() {
      this.currentModule = null;
      let whereobj = this.listQuery.wheres ? JSON.parse(this.listQuery.wheres) : [];
      if (whereobj) {
        whereobj = this.AssTableData([{
          field: 'cInvCCode',
          value: null,
          relation: '=='
        }], whereobj);
      }
      this.listQuery.wheres = JSON.stringify(whereobj);
      this.getList();
    },
    // 递归,只需少量程序就可描述出解题过程，大大减少了程序的代码量。函数将自身作为子例程调用。 简单说程序调用自身的编程技巧叫递归
    recursion(array, data) {
      // 定义临时的数组
      const interim = this.modules.filter(u => u.parentCode === data.cInvCCode);
      for (let i = 0; i < interim.length; i++) {
        // 把子集放进去
        array.push(interim[i].cInvCCode);
        this.recursion(array, interim[i]);
      }
    },
    // 左侧treetable点击事件
    treeClick(data) {
      // 先定义一个数组,放父级和父级本身以及下面子集的数据
      const array = [];
      // 先把自己放进去
      array.push(data.cInvCCode);
      this.recursion(array, data);
      console.log(array);
      this.currentModule = data;
      // this.currentModule.parent = null
      let whereobj = this.listQuery.wheres ? JSON.parse(this.listQuery.wheres) : [];
      if (whereobj) {
        whereobj = this.AssTableData([{
          field: 'cInvCCode',
          value: array.join(),
          relation: 'in'
        }], whereobj);
      }
      this.listQuery.wheres = JSON.stringify(whereobj);
      this.getList();
    },
    // 树结构传出数据方法
    getModulesTree() {
      var _this = this; // 记录vuecomponent
      inventoryclasss.getAllData().then(response => {
        _this.modules = response.result.map(function(item) {
          return {
            id: item.id,
            cInvCCode: item.cInvCCode,
            cInvCName: item.cInvCName,
            parentCode: item.parentCode
          };
        });
        // 将一个带层级的数据列表转成树结构
        var modulestmp = _this.modules.map(o => ({ ...o }));
        _this.modulesTree = _this.$utils.toArrayTree(modulestmp, {
          key: 'cInvCCode',
          parentKey: 'parentCode',
          strict: true
        });
        var modulestmps = _this.modules.map(o => ({ ...o }));
        // 将一个带层级的数据列表转成树结构
        _this.modulesTrees = _this.$utils.toArrayTree(modulestmps, {
          key: 'cInvCCode',
          parentKey: 'parentCode',
          strict: true
        });
      });
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'inventorys') {
        this.drawertemp = { ...this.drawertemp, ...row };
        this.menukeyArray = [
          { name: '', menukey: 'inventorysview' }
        ]; // 要显示的标签
        this.drawer = true;
      }
    },
    // 绑定添加页面table表格input的数据
    beforCreate() {
      const _this = this;
      this.$nextTick(() => {
        accinfos.getList({
          page: 1,
          limit: 9999
        }).then(res => {
          const lkList = _this.$refs['dataForm'].$refs['frmData'].GetModelData('lkList');
          lkList.splice(0);

          // 添加
          res.data.forEach(u => {
            lkList.push({
              accName: u.accName,
              accountId: u.id,
              accYear: u.accYear,
              accCode: u.accCode,
              linkcInvCode: '',
              linkcInvName: '',
              LinkcInvStd: '',
              safetyStock: null,
              edit: false
            });
          });
        });
        _this.getModulesTree();
      });
    },
    // 更新前，当数据发生改变，但页面还没完成更新，但快要更新时调用
    beforUpdate() {
      this.temp.lkList = this.temp.lkList.map(u => {
        return {
          ...{ edit: false },
          ...u
        };
      });
      this.temp.bPurchase = this.temp.bPurchase + '';
      this.getModulesTree();
    },
    // 存货编码的切换按钮
    rowdearchbtn(scope) {
      if (this.dialogStatus === 'update') {
        const tempindex = this.options.findIndex(u => u.linkcInvCode === scope.row.linkcInvCode);
        // 切换input状态
        if (tempindex < 0 && scope.row.linkcInvCode) {
          this.options.splice(0);
          // 添加
          this.options.push({
            linkcInvCode: scope.row.linkcInvCode,
            linkcInvName: scope.row.linkcInvName,
            LinkcInvStd: scope.row.LinkcInvStd
          });
        }
      }
      // 切换按钮
      scope.row.edit = true;
    },
    // 选择下拉框的方法
    selectChange(val, row) {
      // 子节点赋值
      const tempindex = this.options.findIndex(u => u.linkcInvCode === val);
      // 选择子节点
      if (tempindex > -1) {
        row.linkcInvCode = this.options[tempindex].linkcInvCode;
        row.linkcInvName = this.options[tempindex].linkcInvName;
      }
    },
    // 远程搜素，remotemethod方法添加自定义参数
    remoteMethod(query, accountId) {
      if (query !== '') {
        this.selloading = true;
        const wherestr = [];
        // 添加
        wherestr.push({
          field: 'cInvCode',
          value: query,
          relation: 'no'
        });
        erpinventorys.getList({
          page: 1,
          limit: 10,
          wheres: JSON.stringify(wherestr),
          accountId: accountId
        }).then(res => {
          this.options = res.data.map(u => {
            // 返回数据
            return {
              linkcInvCode: u.cInvCode,
              linkcInvName: u.cInvName,
              LinkcInvStd: u.cInvStd
            };
          });
          this.selloading = false;
        }).catch(() => {
          this.selloading = false;
        });
      } else {
        this.options = [];
      }
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#inventorys-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}
</style>
